// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IndustrySlice } from './industrySlice.zod.ts';

export const IndustrySpread = zod.object({
  "industries": zod.int(),
  "slices": zod.array(IndustrySlice),
  "total": zod.int()
});

export type IndustrySpread = zod.input<typeof IndustrySpread>;
export type IndustrySpreadOutput = zod.output<typeof IndustrySpread>;
